import * as React from 'react';
import { useTranslate } from 'react-admin';
import CopyButton, { CopyButtonProps } from './CopyButton';

type Props = Omit<CopyButtonProps, 'mutationType' | 'actionLabel'>;

const TranslateButton = (props: Props) => {
  const t = useTranslate();

  return <CopyButton {...props} mutationType={'createTranslation'} actionLabel={t('common.copy_translate')} />;
};

export default TranslateButton;
